var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { Vue, Component, Emit } from 'vue-property-decorator';
import FileUpload from '~/components/common/file-upload.vue';
import { DataImportExcelInfoService } from "~/services/dataimp-service/data-import-excel-info.service";
import { Dependencies } from "~/core/decorator";
var CaseFileImport = /** @class */ (function (_super) {
    __extends(CaseFileImport, _super);
    function CaseFileImport() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.fileList = [];
        _this.successNumber = '';
        _this.isShow = false;
        _this.importLoading = false;
        _this.matchLoading = false;
        _this.importList = [];
        _this.downloadUrl = '';
        _this.failNumber = '';
        return _this;
    }
    CaseFileImport.prototype.emitClose = function () {
        this.reset();
    };
    Object.defineProperty(CaseFileImport.prototype, "totalNumber", {
        get: function () {
            return parseInt(this.failNumber) + parseInt(this.successNumber);
        },
        enumerable: false,
        configurable: true
    });
    CaseFileImport.prototype.reset = function () {
        this.successNumber = '';
        this.fileList = [];
        this.importList = [];
        this.downloadUrl = '';
        this.isShow = false;
        this.failNumber = '';
    };
    CaseFileImport.prototype.onClickMatch = function () {
        var _this = this;
        var params = this.fileList.map(function (item) { return item.response; });
        this.matchLoading = true;
        this.importExcelService.fileAutoMatch(params).subscribe(function (_a) {
            var success = _a.success, downloadUrl = _a.downloadUrl, result = _a.result, fail = _a.fail, uploaded = _a.uploaded;
            if (uploaded) {
                _this.matchLoading = false;
                _this.successNumber = success;
                _this.failNumber = fail;
                _this.downloadUrl = JSON.parse(downloadUrl);
                _this.importList = result;
                _this.isShow = true;
            }
            else {
                _this.$message.error('请等待文件上传完毕再操作！');
                _this.matchLoading = false;
            }
        }, function () { return (_this.matchLoading = false); });
    };
    CaseFileImport.prototype.onClickImport = function () {
        var _this = this;
        if (this.fileList.length !== this.totalNumber)
            return this.$message.error('上传文件数量和匹配案件数量不符，请重新匹配！');
        var fileStatus;
        fileStatus = this.fileList.map(function (item) {
            var fileNameList = _this.importList.map(function (v) { return v.fileName; });
            if (fileNameList.includes(item.response.fileName))
                return '1';
            return '0';
        });
        if (fileStatus.find(function (v) { return v === '0'; }))
            return this.$message.error('目前还有未匹配的文件，请重新匹配！');
        this.importLoading = true;
        this.importExcelService.fileImport(this.importList).subscribe(function (data) {
            _this.importLoading = false;
            _this.emitClose();
            _this.$message.success('操作成功！');
        }, function () { return (_this.importLoading = false); });
    };
    CaseFileImport.prototype.onClickDownload = function () {
        if (!this.downloadUrl)
            return;
        this.$common.downloadFile(this.downloadUrl.url, '自动匹配详情');
    };
    __decorate([
        Dependencies(DataImportExcelInfoService)
    ], CaseFileImport.prototype, "importExcelService", void 0);
    __decorate([
        Emit('close')
    ], CaseFileImport.prototype, "emitClose", null);
    CaseFileImport = __decorate([
        Component({
            components: {
                FileUpload: FileUpload
            }
        })
    ], CaseFileImport);
    return CaseFileImport;
}(Vue));
export default CaseFileImport;
